import { useEffect } from "react";
import { ChevronDown } from "lucide-react";

export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, [id, data]);
  return null;
};

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

export const FaqList = ({ items }) => (
  <div className="space-y-3" data-testid="faq-list">
    {items.map(([q, a], i) => (
      <details key={q} className="group rounded-xl border border-white/10 bg-[#181A22] p-5 open:border-[#E63946]/40 transition-colors" data-testid={`faq-item-${i}`}>
        <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-semibold">
          <h3 className="text-base">{q}</h3>
          <ChevronDown className="w-5 h-5 shrink-0 text-muted-foreground transition-transform group-open:rotate-180" />
        </summary>
        <p className="text-sm text-muted-foreground leading-relaxed mt-3">{a}</p>
      </details>
    ))}
  </div>
);
